function toSafeIdentifier(str) {
    if (!str) return "";
    let safe = str
        .replace(/[^a-zA-Z0-9_]/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_|_$/g, "");
    if (/^[0-9]/.test(safe)) safe = "X" + safe;
    if (!safe) safe = "Func";
    return safe
        .split("_")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join("");
}

export function buildSharedFunctionName(sourceWorkflowName, sourceComponent) {
    const safeAppName = toSafeIdentifier(sourceWorkflowName);
    const baseName = (sourceComponent.filePath || sourceComponent.name)
        .replace(/^(api\/|functions\/)/, "")
        .replace(/\.(js|ts)$/, "");
    const safeFnName = toSafeIdentifier(baseName);
    return `Shared${safeAppName}${safeFnName}`;
}

export function toSecretPrefix(name) {
    let safe = name
        .toUpperCase()
        .replace(/[^A-Z0-9_]/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_|_$/g, "");
    if (!safe || /^[0-9]/.test(safe)) safe = "APP_" + safe;
    return safe;
}

export function buildSecretName(sourceWorkflowName) {
    return `${toSecretPrefix(sourceWorkflowName)}_API_KEY`;
}

export function buildApiCallSnippet(apiUrl, secretName, functionName) {
    return [
        `// Call ${functionName} API`,
        `const response = await fetch("${apiUrl}", {`,
        `  method: "POST",`,
        `  headers: {`,
        `    "x-server-key": process.env.${secretName},`,
        `    "Content-Type": "application/json",`,
        `  },`,
        `  body: JSON.stringify({ /* your params */ }),`,
        `});`,
        `const data = await response.json();`,
    ].join("\n");
}
